<template>
    <div class="col-lg-12">
        <table-search-and-pagination
            :table-data="preOrderUnits"
            :hide-per-page="true"
            @dataUpdated="queriedData = $event"
        >
            <div slot="header" class="mb-3">
                <div class="flex-between">
                    <base-button
                        v-if="preOrderUnits.length"
                        type="primary"
                        @click="$emit('addUnit')"
                    >
                        Add Unit
                    </base-button>
                </div>
            </div>
            <pre-order-unit-table
                v-if="preOrderUnits.length"
                :pre-order-units="queriedData"
                @orderChanged="$emit('orderChanged', $event)"
                @rowClicked="$emit('rowClicked', $event)"
            />
            <div v-else class="text-center">
                <h4 class="mb-3">You have no units.</h4>
                <base-button type="primary" @click="$emit('addUnit')">
                    Add Unit
                </base-button>
            </div>
        </table-search-and-pagination>
    </div>
</template>
<script>
import moment from "moment-timezone";
import TableSearchAndPagination from "src/components/TableSearchAndPagination";
import PreOrderUnitTable from "./PreOrderUnitTable.vue";

export default {
    name: "PreOrderDetail",
    components: {
        TableSearchAndPagination,
        PreOrderUnitTable,
    },
    props: {
        preOrderUnits: {
            type: Array,
            required: true,
        },
        preOrder: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            queriedData: [],
        };
    },
    methods: {
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
    },
};
</script>
